var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#0A033C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24C8.98333 24 7.68733 23.475 6.612 22.425C5.53667 21.375 4.99933 20.0917 5 18.575C5 17.275 5.39167 16.1167 6.175 15.1C6.95833 14.0833 7.98333 13.4333 9.25 13.15C9.66667 11.6167 10.5 10.375 11.75 9.425C13 8.475 14.4167 8 16 8C17.95 8 19.6043 8.67933 20.963 10.038C22.3217 11.3967 23.0007 13.0507 23 15C24.15 15.1333 25.1043 15.6293 25.863 16.488C26.6217 17.3467 27.0007 18.3507 27 19.5C27 20.75 26.5623 21.8127 25.687 22.688C24.8117 23.5633 23.7493 24.0007 22.5 24H10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/Frame3.e60b79078a315adc7912436de4d9e549.svg";
export { ForwardRef as ReactComponent };